import {
  FilterValue,
  TablePaginationConfig,
  ColumnType,
  SortOrder,
  Key
} from 'antd/lib/table/interface';
import { ESortType, QueryParams } from 'shared/types';

type SorterResult<RecordType> = {
  column?: ColumnType<RecordType> & {
    sortKey?: string;
  };
  order?: SortOrder;
  field?: Key | readonly Key[];
  columnKey?: Key;
};

const getSortValue = (sortKey: string, order: SortOrder): string => {
  const sortType = order === ESortType.ASC ? 'ASC' : 'DESC';
  return `${sortKey},${sortType}`;
};


export const handleSortAction =
  <T>(
    setSortBy: (value: string) => void
  ): ((
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<T> | SorterResult<T>[]
  ) => void) =>
  (pagination, filters, sorter): void => {
    if (Array.isArray(sorter)) {
      const lastWithOrder = [...sorter].reverse().find((item) => item.column && item.order);
      if (lastWithOrder?.column?.sortKey && lastWithOrder.order) {
        setSortBy(getSortValue(lastWithOrder.column.sortKey, lastWithOrder.order));
      } else {
        setSortBy('');
      }
    } else {
      if (sorter.column && sorter.order) {
        setSortBy(getSortValue(sorter.column.sortKey!, sorter.order));
      } else {
        setSortBy('');
      }
    }
  };

export const getSortQueryParams = (values: { [key: string]: string }): QueryParams => {
  const data = Object.entries(values).reduce(
    (acc, item): QueryParams => (!!item[1] ? { ...acc, [item[0]]: item[1] } : acc),
    {}
  );
  return data
}

// Iteratees for `_.orderBy` that lowercase string (and string-array) values so
// alphabetical sorts are case-insensitive instead of bytewise (uppercase first).
export const caseInsensitiveIteratees = (
  fields: string[]
): ((item: any) => unknown)[] =>
  fields.map((field) => (item: any) => {
    const value = item?.[field];
    if (Array.isArray(value)) return value.map((v) => String(v).toLowerCase());
    return typeof value === 'string' ? value.toLowerCase() : value;
  });

